import React, { useEffect, useRef, useState } from "react"
import { Row } from "react-bootstrap"
import Skeleton, { SkeletonTheme } from "react-loading-skeleton"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { RouteComponentProps } from "react-router-dom"
import { authAxios } from "../../../../API/apiRequest"
import { setApplicants } from "../../../../State/Slice/applicantsSlice"
import { IRootState } from "../../../../State/Store"
import MyPagination from "../../Components/Pagination/MyPagination"
import ApplicationCard from "../../JobsManager/ApplicationCard/ApplicationCard"
import classes from '../EmployerJob.module.css'


export interface IApplicationsProps{
    setTotal: (total: number)=>void
}


const Applicant: React.FC<IApplicationsProps & RouteComponentProps<{id: string}>> = (props)=>{
    const myRef = useRef<HTMLDivElement>(null)
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()
    const applicants = useSelector((state: IRootState)=> state.applicants.data)
    const page = useSelector((state: IRootState)=> state.applicants.page)
    const lastPage = useSelector((state: IRootState)=> state.applicants.lastPage)


    useEffect(()=>{
        
        async function getApplications(){
            try{
                let result = await authAxios.get(`/employer/applications/send?jobId=${props.match.params.id}`)
                dispatch(setApplicants({
                    page: 1, 
                    data: result.data.applications, 
                    total: result.data.total, 
                    lastPage: result.data.lastPage,
                    jobId: props.match.params.id
                }))
                props.setTotal(result.data.total)
            }catch(e){
                console.log(e)
            }
            setLoading(false)
        }
        getApplications()
       
    },[dispatch, props])

    const handlePageChange = async(event: React.ChangeEvent<unknown>, value: number)=>{
        setLoading(true)
        if(myRef.current !== null)
            myRef.current.scrollIntoView({behavior: 'smooth'}) 
        try{
            let result = await authAxios.get(`/employer/applications/send?jobId=${props.match.params.id}&page=${value}`)
            dispatch(setApplicants({
                data: result.data.applications, 
                page: value, 
                lastPage: result.data.lastPage,
                total: result.data.total
            }))
            props.setTotal(result.data.total)
        }catch(e){
            console.log(e)
        }
        setLoading(false)
    }
    if(loading) return <ApplicantLoading />
    else{
        if(applicants && applicants.length === 0) return <EmptyList />
        else
        return(
        <React.Fragment>
            <div ref={myRef}>
                <p className={classes.jobText} style={{textAlign: 'center', fontWeight: 'bold'}}>
                    {page} الصفحة
                </p>
            </div>
            {applicants && applicants.map(item=>(
                <ApplicationCard
                    id={item.id}
                    name={item.name}
                    age={item.age}
                    picture={item.picture}
                    edu={item.edu}
                    fromSadat={item.fromSadat}
                    key={item.id}
                />))}
            
            <MyPagination
                page={page}
                pages={lastPage}
                handlePageChange={handlePageChange}
            />
        </React.Fragment>
        )
        }
}

export const ApplicantLoading: React.FC = ()=>{
    return(
        <SkeletonTheme baseColor="gray" highlightColor="#fff">
            <div>
                <p style={{textAlign: 'center'}}>
                    <Skeleton direction='rtl' height={20} width={90} duration={0.8} />
                </p>
            </div>
            <div className='row mx-0 justify-content-center'>
            <div className='col-md-8'>
            <p><Skeleton direction='rtl' borderRadius={10} height={140} duration={0.8} /></p>
            <p><Skeleton direction='rtl' borderRadius={10} height={140} duration={0.8} /></p>
            <p><Skeleton direction='rtl' borderRadius={10} height={140} duration={0.8} /></p>
            </div>
            </div>
        </SkeletonTheme>
    )
}


export const EmptyList: React.FC = ()=>{

    return(
        <Row>
            <div style={{height: 400}}>
                <p className={classes.jobText} style={{textAlign: 'center'}}>القائمة فارغة</p>
            </div>
        </Row>
    )
} 


export default Applicant